import { motion } from "motion/react";
import { cn } from "@babackapp/customer-ui/lib/utils";
import { Slot } from "@radix-ui/react-slot";

export function Stepper({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("w-full flex gap-4 items-center justify-around", className)}
      {...props}
    ></div>
  );
}

export function StepperItem({
  className,
  state = "future",
  children,
  asChild,
  ...props
}: React.ComponentProps<"button"> & {
  state?: "past" | "present" | "future";
  asChild?: boolean;
}) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      className={cn(
        "relative font-sans text-xs font-medium [&_svg]:size-4 inline-flex items-center gap-1 text-foreground/30 transition-[color,opacity,scale] ease-in-out",
        state === "present" ? "text-foreground scale-[1.1] z-0" : "z-[1]",
        className,
      )}
      {...props}
    >
      <div className="contents [&>*:not([data-slot=highlight])]:relative [&>*:not([data-slot=highlight])]:z-90">
        {children}
      </div>
    </Comp>
  );
}

export function StepperDivider({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div className={cn("h-px flex-1 bg-border", className)} {...props}></div>
  );
}

export function StepperHighlight({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <motion.div
      layoutId="highlight"
      className="absolute -inset-y-1 -inset-x-2 z-0"
      data-slot="highlight"
      transition={{
        type: "spring",
        mass: 0.5,
      }}
    >
      <div
        className={cn("size-full rounded-full bg-muted", className)}
        {...props}
      />
    </motion.div>
  );
}
